/**
 * URL 기반 언어 강제 — /en/ SEO 라우트에서 헤더·푸터를 포함한 전역 i18n 을
 * 해당 언어로 전환한다. (ForceDarkTheme 와 동일 패턴: 마운트 시 전환, 언마운트 시 복원)
 *
 * 왜 필요한가: 공용 Header/Footer 는 useTranslation() 으로 렌더되므로,
 * 페이지 본문만 영어로 강제하면 상단 메뉴·하단 푸터는 한국어로 남는다.
 * URL(/blog=ko, /en/blog=en)이 페이지 전체 언어를 결정하도록 통일한다.
 */
import { useEffect } from 'react'
import i18n from '../../features/i18n'

export default function ForceLocale({ lang }: { lang: 'ko' | 'en' }) {
  useEffect(() => {
    const prev = i18n.language
    if (prev !== lang) i18n.changeLanguage(lang)
    return () => {
      if (i18n.language !== prev) i18n.changeLanguage(prev)
    }
  }, [lang])
  return null
}
